import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { AuthContext } from '../context/AuthContext';

export function useLogoutConfirmation() {
  const { logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  return { requestLogout: () => setOpen(true), logoutDialog: <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="logout-confirmation-title" maxWidth="xs" fullWidth>
      <DialogTitle id="logout-confirmation-title">Log out?</DialogTitle>
      <DialogContent><DialogContentText>You will need to sign in again to use CAD.</DialogContentText></DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => setOpen(false)}>Stay signed in</Button>
        <Button color="error" variant="contained" onClick={() => { setOpen(false); logout(); }}>Log out</Button>
      </DialogActions>
    </Dialog> };
}

export default function ConfirmLogoutButton({ children = 'Log Out', ...props }) {
  const { requestLogout, logoutDialog } = useLogoutConfirmation();
  return <><Button {...props} onClick={requestLogout}>{children}</Button>{logoutDialog}</>;
}
